import {ScaleModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/scale/ScaleModel';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export abstract class ScaleFieldPaths
{
    public static readonly IS_ENABLED:FieldPath = 'isEnabled';
    public static readonly IS_UNIFORM:FieldPath = 'isUniform';
    public static readonly SCALE:FieldPath = 'scale';
    public static readonly SCALE_X:FieldPath = 'scaleX';
    public static readonly SCALE_Y:FieldPath = 'scaleY';
    public static readonly SCALE_Z:FieldPath = 'scaleZ';
}

export class ScaleConverter extends BaseFieldConverter<ScaleModel>
{
}
